import React from "react";
import { useTranslation } from "react-i18next";

//IMG
import imgService1 from "../../../public/assets/images/locations/contratto.jpg";
import imgService2 from "../../../public/assets/images/locations/riunione.jpg";


const ServicesMain: React.FC = () => {

    const { t } = useTranslation();

    const list1 = [
        t('servicesPage.list1Element1'),
        t('servicesPage.list1Element2'),
        t('servicesPage.list1Element3'),
        t('servicesPage.list1Element4'),
        t('servicesPage.list1Element5'),
        t('servicesPage.list1Element6'),
        t('servicesPage.list1Element7'),
        t('servicesPage.list1Element8'),
        t('servicesPage.list1Element9'),
        t('servicesPage.list1Element10'),
        t('servicesPage.list1Element11'),
        t('servicesPage.list1Element12'),
    ]

    const list2 = [
        t('servicesPage.list2Element1'),
        t('servicesPage.list2Element2'),
        t('servicesPage.list2Element3'),
        t('servicesPage.list2Element4'),
        t('servicesPage.list2Element5'),
        t('servicesPage.list2Element6'),
        t('servicesPage.list2Element7'),
        t('servicesPage.list2Element8'),
        t('servicesPage.list2Element9'),
    ]
    
    return(
        <section>
            <h2>{t('servicesPage.sectionTitle1')}</h2>
            <p dangerouslySetInnerHTML={{ __html: t('servicesPage.para1') as string }}></p>
            <div className="row">
                <div className="col-12 col-xl-10">
                    <img src={imgService1} className="img-fluid" alt="" />
                    <div className="service-list">
                        <h3>{t('servicesPage.sectionTitle2')}</h3>
                        <ul>
                            {list1.map((listElement, index) => (
                                <li key={index}>{listElement}</li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div className="col-12 col-xl-10">
                    <img src={imgService2} className="img-fluid" alt="" />
                    <div className="service-list">
                        <h3>{t('servicesPage.sectionTitle3')}</h3>
                        <ul>
                            {list2.map((listElement, index) => (
                                <li key={index}>{listElement}</li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    )
};
export default ServicesMain;